export default "__VITE_ASSET__stgHNk4_TpJ333nyAmmqBQ__";